import React from "react";
import "./Image.scss";
import { IMediaElement } from "../../../types/IMediaElement";

export default function Image({ id, className, src, alt, onClick }: IMediaElement) {
    return <img id={id} className={className} src={src} alt={alt} onClick={onClick} />;
}